'use client'

import { TFunction } from 'i18next'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { z } from 'zod/v4'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const localeMappings: Record<string, () => Promise<any>> = {
  en: () => import('zod/v4/locales/en.js'),
  sv: () => import('zod/v4/locales/sv.js'),
}

export async function loadZodLocale(t: TFunction, locale: keyof typeof localeMappings) {
  try {
    const localeLoader = localeMappings[locale] ?? localeMappings.en
    if (!localeLoader) return
    const { default: getTranslations } = await localeLoader()
    const translations = getTranslations()

    z.config({
      ...translations,
      customError: issue => {
        if (issue.code === 'invalid_type' && typeof issue.input === 'undefined') {
          return t('defaultFormErrors.required')
        }

        if (issue.code === 'invalid_format') {
          return t('defaultFormErrors.invalidFormat', { context: issue.format })
        }

        console.log('issue', issue)

        if (issue.code === 'invalid_value') {
          return t('defaultFormErrors.invalidValue')
        }

        if (issue.code === 'too_small') {
          let context = issue.origin

          if (issue.path?.join().toLowerCase().includes('password')) {
            context = 'password'
          }

          return t('defaultFormErrors.tooSmall', { context, min: issue.minimum })
        }

        if (issue.code === 'too_big') {
          return t('defaultFormErrors.tooBig', { context: issue.origin, max: issue.maximum })
        }

        return translations?.customError?.(issue)
      },
    })
  } catch (error) {
    console.error(`Failed to load Zod locale for ${locale}:`, error)
  }
}

export const useZodLocale = () => {
  const {
    i18n: { language },
    t,
  } = useTranslation()

  useEffect(() => {
    loadZodLocale(t, language)
  }, [language, t])
}
